export default {
  // Header
  'header.features': '功能特色',
  'header.whyDifferent': '為何不同',
  'header.faq': '常見問題',
  'header.joinEarlyAccess': '加入搶先體驗',

  // Hero Section
  'hero.title.part1': '與你的AI夥伴一起',
  'hero.title.part2': '告別手機成癮',
  'hero.description': 'Scrollmate 是一個 AI 朋友,了解你的習慣、目標,以及你最容易陷入',
  'hero.description.highlight': '無止盡滑動',
  'hero.description.part2': '的時刻——像一位關心你的朋友般溫柔地出現,在下一個小時消失前幫助你暫停。',
  'hero.joinEarlyAccess': '加入搶先體驗',
  'hero.learnMore': '了解更多',

  // Core Features
  'features.title': '3 大核心功能',
  'features.feature1.title': '它了解你的目標',
  'features.feature1.description': '你可以直接設定目標或與行事曆同步。無論你想早點睡覺還是減少深夜滑手機,你的朋友都會記住並溫柔地支持你。',
  'features.feature2.title': '它能即時介入',
  'features.feature2.description': 'Scrollmate 不會封鎖或責備,而是在你陷入循環時適時出現——幫助你帶著覺察而非罪惡感暫停。',
  'features.feature3.title': '它理解你的習慣',
  'features.feature3.description': 'Scrollmate 學習你容易失控的時刻——尤其是夜晚。它在你最脆弱的時段提供及時、關懷的支持。',

  // Why Different
  'whyDifferent.title': '為什麼 Scrollmate 與眾不同',
  'whyDifferent.notBlocker.title': '不是封鎖工具',
  'whyDifferent.notBlocker.description': '大多數封鎖工具把你的滑動視為紀律問題,而非人性模式。',
  'whyDifferent.notReporter.title': '不是螢幕時間報告器',
  'whyDifferent.notReporter.description': '螢幕時間報告器只顯示過去,從不在你真正需要支持的當下幫助你。',
  'whyDifferent.whatItIs.title': 'Scrollmate是...',
  'whyDifferent.whatItIs.point1.title': '它知道你想要什麼',
  'whyDifferent.whatItIs.point1.description': '你的目標、意圖,以及你試圖建立的更健康習慣。',
  'whyDifferent.whatItIs.point2.title': '它知道你何時失控',
  'whyDifferent.whatItIs.point2.description': '你的脆弱時段,尤其是深夜最難停下來的時候。',
  'whyDifferent.whatItIs.point3.title': '它知道如何幫你暫停',
  'whyDifferent.whatItIs.point3.description': '溫柔的即時支持,而非壓力、罪惡感或強制封鎖。',
  'whyDifferent.whatItIs.quote': '「Scrollmate 是圍繞理解你而建立——而非限制你。」',

  // Gallery
  'gallery.image1.label': '圖片 #5 – 夥伴情感',
  'gallery.image1.caption': '一系列 AI 角色,每個都有獨特的個性和情感風格。',
  'gallery.image2.label': '圖片 #6 – 介面概念',
  'gallery.image2.caption': '基於關係的親密度系統,隨著你建立更健康的習慣而變得更強。',
  'gallery.image3.label': '圖片 #7 – 進度總覽',
  'gallery.image3.caption': '清晰的每週勝利儀表板,慶祝你的數位健康成就。',

  // FAQ
  'faq.title': '常見問題',
  'faq.q1': 'Scrollmate 會記錄我的螢幕嗎?',
  'faq.a1': '不會。它偵測模式,而非內容。',
  'faq.q2': '它會支援哪些平台?',
  'faq.a2': '我們正在測試瀏覽器和行動優先的體驗。',
  'faq.q3': '何時會推出?',
  'faq.a3': '搶先體驗成員將率先知道。',

  // Email Signup
  'signup.title': '加入搶先體驗',
  'signup.subtitle': '成為第一批試用 Scrollmate 的用戶。你將獲得搶先體驗、更新資訊和獨家功能。',
  'signup.emailPlaceholder': '輸入你的電子郵件',
  'signup.button': '獲得搶先體驗',
  'signup.submitting': '提交中...',
  'signup.success': '你已加入!我們很快會聯繫你。',

  // Footer
  'footer.description': '你的 AI 朋友,了解你的習慣,引導你遠離手機成癮。',
  'footer.contact': '聯絡我們',
  'footer.privacy': '隱私政策',
  'footer.terms': '服務條款',
  'footer.copyright': '© Scrollmate – 由 Noffice Studio 打造。',
  'footer.poweredBy': '技術支援 Readdy',
};
